import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import reportWebVitals from "./reportWebVitals";

import "react-circular-progressbar/dist/styles.css";
import "./style/custom.scss";

// The app uses hash routing, so its parameters belong after "#/". A link
// written without it (focussuite.de/?agenda=...) would open an empty board,
// so move the query into the hash before the router reads it.
if (window.location.search && !window.location.hash) {
  window.history.replaceState(
    null,
    "",
    `${window.location.pathname}#/${window.location.search}`
  );
}

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
